import { DataType } from "../../../../form/typings";
import { styleControlOptions } from "../../../../form/component-schema";
export default {
    $id: "label",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {},
};
